import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	logInWithPartnerDescription: {
		id: 'b2b.renew.logInWithPartner.description',
		defaultMessage:
			'In order to renew your Calm Premium subscription please sign into your {partnerName} account.',
		description:
			'Instructions for how to renew their subscription by re-verifying their access via a business partner',
	},
	logInWithPartnerButton: {
		id: 'b2b.renew.logInWithPartner.button',
		defaultMessage: 'Go to {partnerName}',
		description:
			'Button to begin renewing their subscription by re-verifying their access via a business partner',
	},
	renewWithCalmInsteadDescription: {
		id: 'b2b.renew.renewWithCalmInstead.description',
		defaultMessage:
			'If you’re no longer eligible for Calm access through {partnerName}, you can renew your Calm Subscription here',
		description:
			'Instructions for how to renew their subscription directly with Calm (as opposed to a business partner)',
	},
	renewWithCalmDescription: {
		id: 'b2b.renew.renewWithCalm.description',
		defaultMessage:
			'Your access to Calm through {partnerName} has now expired. You can renew your Calm Subscription here',
		description: 'Instructions for how to renew their subscription directly with Calm',
	},
	renewWithCalmButton: {
		id: 'b2b.renew.renewWithCalm.button',
		defaultMessage: 'Renew myself',
		description:
			'Button to begin renewing their subscription directly with Calm (as opposed to a business partner)',
	},
});
